const state = {
    closeAddCompany: false
};

const getters = {
    getcloseAddCompany(state) {
        return state.closeAddCompany;
    }
};
const mutations = {
    setcloseAddCompany(state, data) {
        state.closeAddCompany = data;
    }
};
const actions = {};

export default { state, getters, mutations, actions };
